import React from 'react';
import { Link } from 'react-router-dom';

export const FLink = ({
  to,
  className,
  children,
  disabled,
  icon,
  iconLeft,
  link = true,
  ...props
}) => {
  return to ? (
    <Link
      {...props}
      className={`${link && 'link'} ${className} ${disabled ? 'disabled' : ''}`}
      to={to}
    >
      {children}
      {icon ? <i className="icon-arrow_forward" /> : ''}
    </Link>
  ) : (
    <a
      {...props}
      className={`${link && 'link'} ${className} ${disabled ? 'disabled' : ''}`}
    >
      {iconLeft ? <i className={`me-2 ${iconLeft}`} /> : ''}
      {children}
      {icon ? <i className={`ms-2 ${icon}`} /> : ''}
    </a>
  );
};
